export const fetchActionsHistoryListUrl = '/actions/history';
export const fetchActionsHistoryFiltersUrl = '/actions/history/list/filters';
export const fetchActionsHistoryViewUrl = '/actions/history';